<template>
  <div v-if="getQuoteSingle">
    <appQuoteViewCom
      :propsData="getQuoteSingle"
      :quoteType="'maturing'"
    ></appQuoteViewCom>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import appQuoteViewCom from '../../../components/quote/quoteViewCom.vue'
export default {
  name: 'maturingQuoteView',
  props: ['quoteType'],
  components: {
    appQuoteViewCom
  },
  data() {
    return {
      quoteId: this.$route.params.quoteId
    }
  },
  computed: {
    ...mapGetters(['getQuoteSingle'])
  },
  methods: {
    ...mapActions(['fetchQuoteSingle'])
  },
  async created() {
    await this.fetchQuoteSingle({ id: this.quoteId, quoteType: 'quote' })
  }
}
</script>
